export default "__VITE_ASSET__jw37X2VF__"